import { isArray, isNull, isNumber, isObject, isString, isFinite, isUndefined } from 'lodash'

import { APP_MODAL_SIZES } from '@/utils/components-configurations/app-modal'

import { DROP_LIST_THEMES } from './components-configurations/app-droplist'
import { CONFIGURABLE_PROGRESS_MODULE_COLUMNS } from './custom-dashboard-helper'

export const indicatorPanelValidator = v => !Number.isNaN(v) && v <= Infinity && v >= 0
export const objectOrNullProp = prop => (isObject(prop) && !isArray(prop)) || isNull(prop)
export const numberOrNullProp = prop => isFinite(prop) || isNull(prop)
export const stringOrNullProp = prop => isString(prop) || isNull(prop)

export const modalSizePropValidator = prop => {
  const isSizeInPixels = isNumber(prop)

  if (isSizeInPixels) {
    return prop >= 0 && Number.isSafeInteger(prop) && Number.isFinite(prop) && !Number.isNaN(prop)
  } else {
    return Object.values(APP_MODAL_SIZES).includes(prop) // DO NOT REMOVE [SM, SM-NEXT, LG, LG-NEXT] SIZES WHILE REFACTORING
  }
}

export const datePickerModePropValidator = (_, props) => {
  const { weekPicker, monthPicker, quarterPicker } = props

  const enabledPickerModesCount = weekPicker + monthPicker + quarterPicker

  if (enabledPickerModesCount > 1) {
    throw new Error(
      'Only one picker mode can be enabled at a time (weekPicker, monthPicker, quarterPicker)'
    )
  }

  return enabledPickerModesCount <= 1
}

export const isAllThemesValid = v => {
  const themes = v.split(' ')
  return themes.every(theme => Object.values(DROP_LIST_THEMES).includes(theme))
}

export const progressModuleConfigurableColumnsPropValidator = v => {
  return v.every(column => CONFIGURABLE_PROGRESS_MODULE_COLUMNS.includes(column))
}

export const includesValue = (v, object = {}) => {
  if (isUndefined(v)) {
    throw new Error('The value to search for must be provided')
  }
  return Object.values(object).includes(v)
}

export const mapValuesByKey = (object, key) => {
  if (!isObject(object)) {
    throw new Error('The object to map must be provided')
  }
  return Object.values(object).reduce((acc, item) => {
    if (key in item) {
      acc.push(item[key])
    }
    return acc
  }, [])
}
